import { Controller } from "@hotwired/stimulus"

export default class IFrameController extends Controller {
  static targets = ["container"]

  connect() {
    this.resizeToFitContent()
  }

  resizeToFitContent() {
    const htmlDocument =
      this.#target.contentWindow.document.querySelector("html")
    const contentHeight = htmlDocument.scrollHeight
    this.#target.style.height = `${contentHeight}px`
  }

  get #target() {
    return this.hasContainerTarget ? this.containerTarget : this.element
  }
}
